import { useTranslation } from 'react-i18next';
import { Oval } from "react-loader-spinner";


function useTranslationWithLoading(ns) {
	const { t, ready } = useTranslation(ns)

	const translate = (key) => {
		if (ready) {
			return t(key)
		} else {
			return <Oval height="20" width="20" color="#4fa94d" ariaLabel="oval-loading" />
		}
	}

	return { 
		t: translate, 
		ready
	}
}

export default useTranslationWithLoading;